import React from "react";

const CrmBox = () => {
    return(
        <div className="box">
            <div className="box-title">Sync</div>
            <div className="box-form">
                <p>Your team can <a href="/">connect with CRMs</a> to Panacea so that campaign activity is synced.</p>
                <p>No CRM are currently connected for your team</p>
            </div>
            <div className="box-action">
                {/* <button className="primary-btn">Save</button> */}
            </div>
        </div>
    );
}

export default CrmBox;